import React from 'react'

export const Error404 = () => {
    return (
        <div>
            <h2>Error 404...</h2>
        </div>
    )
}
